
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsc606fac9f425074d49e18de6b4b43222en from './en.yaml'
            i18n.addResourceBundle('en', 'c606fac9f425074d49e18de6b4b43222', flattenObject(nsc606fac9f425074d49e18de6b4b43222en), true, true);
        
        export default 'c606fac9f425074d49e18de6b4b43222';
    